import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import LayeringIcon from '../../../../../../icons/LayeringIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerLayerControlsButton = ({ className, onClick, active }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<LayeringIcon />}
      title="Layering"
      onClick={onClick}
    />
  );
};

CardDesignerLayerControlsButton.propTypes = propTypes;

export default CardDesignerLayerControlsButton;
